import {TinctIcon, TinctIconProps} from "./tinct-icon";

type TinctBadgeProps = {
  label?: string;
  iconProps?: TinctIconProps
}
export const TinctBadge = (props: TinctBadgeProps) => {
  const { label: planName = 'Pro', iconProps } = props;
  return <div className="rounded-md bg-gradient-to-tr from-blue-500 via-violet-500 to-fuchsia-300 p-[2px]">
    <div className="flex items-center gap-1 rounded-[6px] bg-background px-2 py-0.5">
      <TinctIcon  className="size-3" {...iconProps }/>
      <span className="text-xs font-semibold">{planName}</span>
    </div>
  </div>
}
